import styled, { css } from 'styled-components';
import COLORS from '../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../common/styles/fontStyles';

const DropDownWrapper = styled.div<{
  $valueExist: boolean;
  disabled?: boolean;
  $invalid?: boolean;
  $delayTransaction?: boolean;
  $dropDownHeight?: number;
  $inputResponcive?: number;
}>`
  width: 325px;
  position: relative;
  transition: all 0.2s ease-in;
  font-family: ${FONT_FAMILY.hellix.regular} !important;
  @media only screen and (max-device-width: 320px) {
    width: 100%;
  }
  @media only screen and (min-width: 321px) and (max-device-width: 900px) and (orientation: landscape) {
    width: 100%;
  }
  p {
    font-size: 16px;
    line-height: 22px;
    position: absolute;
    top: 95%;
    left: 0;
    color: ${(p) => (p.$invalid ? '#FE0000' : '#f20095')} !important;
    animation: animateText 0.5s;
  }
  @keyframes animateText {
    0% {
      opacity: 0;
      transform: translateY(-2px);
    }
    100% {
      opacity: 1;
      transform: translateY(0px);
    }
  }
  .drop-down-input {
    width: 100%;
    position: relative;
    display: flex;
    margin-bottom: ${(p) => (p.$invalid ? '30px' : '20px')};
    height: 50px;
    font-family: ${FONT_FAMILY.hellix.regular} !important;
    flex-direction: row;
    border-radius: 4px;
    background-color: ${COLORS.white};
    border: 1px solid
      ${(p) =>
        p.$invalid ? '#FE0000' : p.disabled ? '#A9A9A9' : p.$valueExist ? '#F0F0F0' : '#A9A9A9'};
    transition: all 0.2s ease-in;

    label {
      position: absolute;
      left: 19px;
      top: 50%;
      font-weight: 400;
      font-family: ${FONT_FAMILY.hellix.regular} !important;
      transform: translateY(-50%);
      background-color: inherit;
      transition: all 0.1s ease-in;
      transition-delay: ${(p) => (p.$delayTransaction ? '0s' : '.18s')};
      color: ${(p) => (p.$invalid ? '#FE0000' : p.disabled ? '#A9A9A9' : '#747474')};
      border-radius: 50%;
      ${(p) =>
        p.$valueExist &&
        css`
          top: 0px;
          left: 16px;
          padding: 0 4px;
          font-size: 14px;
          color: ${p.$invalid ? '#FE0000' : p.disabled ? '#A9A9A9' : '#000'};
        `}
      &:hover {
        border: none;
      }
    }
    input {
      outline: none;
      border: none;
      font-size: 18px;
      padding-left: ${(p) =>
        p.$inputResponcive === 4 ? '14px' : p.$inputResponcive === 5 ? '8px' : '19px'};
      border-radius: 4px;
      background-color: ${COLORS.white};
      color: ${(p) => (p.disabled ? '#A9A9A9' : '#333')};
      min-width: 78px;
      flex: 2;
      caret-color: ${(p) => (p.$invalid ? '#FE0000' : '#f20095')};
    }
    img {
      height: 20px;
      width: 20px;
      align-self: center;
      margin-right: 13px;
      cursor: pointer;
      box-sizing: border-box;
      position: absolute;
      right: 0;
      &:hover: {
        border: none;
      }
    }
    &:hover {
      border: 1px solid ${(p) => (p.$invalid ? '#FE0000' : p.disabled ? '#A9A9A9' : '#000')};
    }
  }
  .drop-down-input:focus-within {
    z-index: 1;
    border-color: ${(p) => (p.$invalid ? '#FE0000' : '#000')};
    label {
      top: 0px;
      left: 16px;
      padding: 0 4px;
      font-family: ${FONT_FAMILY.hellix.regular};
      font-size: 14px;
      color: ${(p) => (p.$invalid ? '#FE0000' : '#000')};
    }
  }
  .drop-down-value {
    position: absolute;
    background-color: ${COLORS.white};
    top: 100%;
    font-family: ${FONT_FAMILY.hellix.regular};
    margin-top: 10px;
    border: 1px solid ${COLORS.borderGrey};
    min-height: ${(p) =>
      p.$dropDownHeight === 1
        ? '52px'
        : p.$dropDownHeight === 2
        ? '104px'
        : p.$dropDownHeight === 3
        ? '156px'
        : 'auto'};
    z-index: 3;
    left: 0;
    right: 0;
    width: 325px;
    border-radius: 3px;
    max-height: 203px;
    overflow-y: auto;
    box-shadow: 1px 2px 2px rgba(0, 0, 0, 0.03);
    li {
      min-height: 50px;
      width: 100%;
      text-align: left;
      padding: 13px 19px;
      cursor: pointer;
      display: flex;
      align-items: center;
      font-family: ${FONT_FAMILY.hellix.regular};
      word-break: break-word;
      line-height: 20px;
    }
    .change-bg-clr {
      background-color: #f5f5f5;
    }
    li:hover {
      background-color: rgba(72, 249, 254, 0.4);
    }
  }
  .drop-down-value::-webkit-scrollbar-track {
    background-color: transparent;
    -webkit-box-shadow: none;
    border-radius: 0px;
  }

  .drop-down-value::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: transparent;
  }

  .drop-down-value::-webkit-scrollbar-thumb {
    border-radius: 20px;
    height: 50px;
    border: 2px solid;
    border-color: transparent;
    background-clip: padding-box;
    -webkit-border-radius: 20px;
    box-shadow: none;
    -webkit-box-shadow: none;
    background-color: ${COLORS.borderGrey};
  }
`;

export default DropDownWrapper;
